module.exports = __webpack_public_path__ + "static/img/remotekey.f4bb417.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/software/wxMini/remotekey.jpg
// module id = fBFH
// module chunks = 0